export enum ProcessStatusEnum {
    NEW = 1,
    IN_PROGRESS = 2,
    ARCHIVED = 3,
    CONCLUDED = 4,
    IN_CORRECTION = 5,
    OUTDATED = 6,
    CANCELED = 7,
    ANSWERED = 8,
    EXPIRED_WITHOUT_ANALYSIS = 9,
    AWAITING_REFUND = 10,
    PENDING_WITHOUT_RESPONSIBLE = 11,
    AWAITING_PAYMENT = 12,
    APENSADO = 13,
    AWAITING_SECRETARY_SIGNATURE = 14
}
